/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { DialogDefaultV2 } from '../../../../../components/v2';

const ReatribuidaDialog = ({ open, message, onClose }) => (
  <DialogDefaultV2
    open={open}
    handlerCancel={onClose}
    handlerConfirm={onClose}
    title="Digitação reatribuída"
    confirmMessage="Fechar"
    readOnly
    maxWidth="sm"
    fullWidth
  >
    {message}
  </DialogDefaultV2>
);

ReatribuidaDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

ReatribuidaDialog.defaultProps = {
  message: 'Esta NSIR foi reatribuída. Suas alterações não foram salvas.',
};

export default ReatribuidaDialog;
